import { render, staticRenderFns } from "./SuporteCategoria.vue?vue&type=template&id=7463f752&"
import script from "./SuporteCategoria.vue?vue&type=script&lang=js&"
export * from "./SuporteCategoria.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports